// Module
var code = `<div class="svc-property-grid-placeholder">
  <div class="svc-property-grid-placeholder__header">
    <span class="svc-property-grid-placeholder__title" data-bind="text: title"></span>
    <span class="svc-property-grid-placeholder__description" data-bind="text: description"></span>
  </div>
  <div class="svc-property-grid-placeholder__content">
    <div class="svc-property-grid-placeholder__gap"></div>
    <div class="svc-property-grid-placeholder__image"></div>
  </div>
</div>`;
// Exports
export default code;